module.exports = __webpack_public_path__ + "img/image-18.41a88c63.webp";